const normalCodeType = {
    bqlb: '304000',//保全类别
    bqlx: '301000',//保全类型
    fsqj: '301110', //非诉期间
    tjrsf: '118000', //提交人身份
    dbqk: '130000',//担保情况
    dbfs: '202000',//担保方式
    dbcclx: '112000',// 担保财产类型
    ajlx: '121000', // 案件类型
    sqrlx: '101000',//申请人类型
    zjlx: '105000',//证件类型
    mz: '120000',//民族
    dwxz: '108000',//单位性质
    xb: '110000',//性别
    dlrlx: '103000',//代理人类型
    cclx: '112000',//财产类型
    bz: '119000',//币种
    dw: '131000',//单位
    shjg: '128000',//审核结果
    zfxt: '117000',//交费方式
    jfzt: '129000',//交费状态
    cdjgss: '301600',//裁定结果  诉讼
    cdjgsq: '301120',//裁定结果  诉前
    cllx: '132000',//车辆类型
    bxgs: '127000',//保险公司
    dbzt: '206000',//担保状态
    tjrlx: '301140',//提交人类型
    bgsx: '204000',//担保变更事项
    appid: '502000',//法院对应appid
    xxshjg: '116000',//审核结果
    dbcclxft: '502002'
};

const btnType = {
    XZBD_BUTTON: 1, // 显示  下载保单按钮               担保有
    XZBH_BUTTON: 2, // 显示  下载保函  按钮             担保有
    BJ_BUTTON: 4, // 显示  编辑  按钮                   保全有, 担保也有
    SC_BUTTON: 5, // 显示  删除  按钮                   保全有, 担保也有
    JF_BUTTON: 6, // 显示  交费 按钮                    保全有, 担保也有
    QXDB_BUTTON: 7, // 显示  取消担保  按钮             担保有
    PJ_BUTTON: 8, // 显示  评价  按钮                   担保有
    BCCL_BUTTON: 9, // 显示  补充材料  按钮             保全有
    JCBQ_BUTTON: 10, // 显示  解除保全  按钮            保全有
    BGDB_BUTTON: 11, // 显示  变更担保 按钮             保全有
    BCDB_BUTTON: 12, // 显示  补充担保 按钮             保全有
    XXBQ_BUTTON: 13, // 显示  续行保全  按钮            保全有
    XQ_BUTTON: 14, // 显示  详情  按钮                  保全有, 担保也有
    QXBQ_BUTTON: 15, // 显示  取消保全  按钮            保全有
    SQBQ_BUTTON:16,  // 显示  申请保全  按钮            担保有
    SQFY_BUTTON: 17, // 显示  申请复议  按钮            担保有
    CXSQFY_BUTTON: 18, // 显示  复议-重新申请  按钮            复议列表
    SQKP_BUTTON: 19, // 显示 申请开票 按钮              担保有
    CKKP_BUTTON: 20, // 显示 查看申请开票信息 按钮       担保有
    SQTB_BUTTON: 21, // 显示 申请退保 按钮               担保有
    CXSQ_BUTTON: 22, // 显示  重新申请  按钮            担保有
    SQBG_BUTTON: 23 // 显示  申请变更  按钮            担保有

};

// 公共的申请保全类型
const COMMON_BTN_TYPE = {
    XZBD_BUTTON: 1, // 显示  下载保单按钮               担保有
    XZBH_BUTTON: 2, // 显示  下载保函  按钮             担保有
    BJ_BUTTON: 4, // 显示  编辑  按钮                   保全有, 担保也有
    SC_BUTTON: 5, // 显示  删除  按钮                   保全有, 担保也有
    JF_BUTTON: 6, // 显示  交费 按钮                    保全有, 担保也有
    QXDB_BUTTON: 7, // 显示  取消担保  按钮             担保有
    PJ_BUTTON: 8, // 显示  评价  按钮                   担保有
    BCCL_BUTTON: 9, // 显示  补充材料  按钮             保全有
    JCBQ_BUTTON: 10, // 显示  解除保全  按钮            保全有
    BGDB_BUTTON: 11, // 显示  变更担保 按钮             保全有
    BCDB_BUTTON: 12, // 显示  补充担保 按钮             保全有
    XXBQ_BUTTON: 13, // 显示  续行保全  按钮            保全有
    XQ_BUTTON: 14, // 显示  详情  按钮                  保全有, 担保也有
    QXBQ_BUTTON: 15, // 显示  取消保全  按钮            保全有
    SQBQ_BUTTON:16,  // 显示  申请保全  按钮            担保有
    CXSQFY_BUTTON: 18, // 显示  复议-重新申请  按钮            复议列表
    SQKP_BUTTON: 19, // 显示 申请开票 按钮              担保有
    CKKP_BUTTON: 20, // 显示 查看申请开票信息 按钮       担保有
    SQTB_BUTTON: 21, // 显示 申请退保 按钮               担保有
    CXSQ_BUTTON: 22, // 显示  重新申请  按钮            担保有
    SQBG_BUTTON: 23 // 显示  申请变更  按钮            担保有
};

// 申请保全按钮类型
const SQBQ_BTN_TYPE = {
    // 公共按钮类型
    ...COMMON_BTN_TYPE,
    SQFY_BUTTON: 17 // 显示  申请复议  按钮            担保有
};

// 申请担保按钮类型
const SQDB_BTN_TYPE = {
    // 公共按钮类型
    ...COMMON_BTN_TYPE,
    // 显示  查看评价  按钮            担保有
    CKPJ_BUTTON: 17
};
// 公共按钮类型map对象
const COMMON_TYPE_MAP = {
    // 1 显示  下载保单按钮               担保有
    [btnType.XZBD_BUTTON]: {
        text: '下载保单',
        type: btnType.XZBD_BUTTON
    },
    // 2 显示  下载保函  按钮             担保有
    [btnType.XZBH_BUTTON]: {
        text: '下载保函',
        type: btnType.XZBH_BUTTON
    },
    // 4 显示  编辑  按钮                   保全有, 担保也有
    [btnType.BJ_BUTTON]: {
        text: '编辑',
        type: btnType.BJ_BUTTON
    },
    // 5 显示  删除  按钮                   保全有, 担保也有
    [btnType.SC_BUTTON]: {
        text: '删除',
        type: btnType.SC_BUTTON
    },
    // 6 显示  交费 按钮                    保全有, 担保也有
    [btnType.JF_BUTTON]: {
        text: '交费',
        key: 'jf',
        type: btnType.JF_BUTTON
    },
    // 7 显示  取消担保  按钮             担保有
    [btnType.QXDB_BUTTON]: {
        text: '取消担保',
        type: btnType.QXDB_BUTTON
    },
    // 8 显示  评价  按钮                   担保有
    [btnType.PJ_BUTTON]: {
        text: '评价',
        type: btnType.PJ_BUTTON
    },
    // 9 显示  补充材料  按钮             保全有
    [btnType.BCCL_BUTTON]: {
        text: '补充材料',
        type: btnType.BCCL_BUTTON
    },
    // 10 显示  解除保全  按钮            保全有
    [btnType.JCBQ_BUTTON]: {
        text: '解除保全',
        key: 'jcbq',
        type: btnType.JCBQ_BUTTON
    },
    // 11 显示  变更担保 按钮             保全有
    [btnType.BGDB_BUTTON]: {
        text: '变更担保',
        key: 'bgdb',
        type: btnType.BGDB_BUTTON
    },
    // 12 显示  补充担保 按钮             保全有
    [btnType.BCDB_BUTTON]: {
        text: '补充担保',
        key: 'bcdb',
        type: btnType.BCDB_BUTTON
    },
    // 13 显示  续行保全  按钮            保全有
    [btnType.XXBQ_BUTTON]: {
        text: '续行保全',
        key: 'xxbq',
        type: btnType.XXBQ_BUTTON
    },
    // 14 显示  详情  按钮                  保全有, 担保也有
    [btnType.XQ_BUTTON]: {
        text: '详情',
        key: 'xq',
        type: btnType.XQ_BUTTON
    },
    // 15 显示  取消保全  按钮            保全有
    [btnType.QXBQ_BUTTON]: {
        text: '取消保全',
        type: btnType.QXBQ_BUTTON
    },
    // 16 显示  申请保全  按钮            担保有
    [btnType.SQBQ_BUTTON]: {
        text: '申请保全',
        type: btnType.SQBQ_BUTTON
    },
    // 22 显示  重新申请  按钮            担保有
    [btnType.CXSQ_BUTTON]: {
        text: '重新申请',
        type: btnType.CXSQ_BUTTON
    },
    // 23 显示  申请变更  按钮            担保有
    [btnType.SQBG_BUTTON]: {
        text: '申请变更',
        type: btnType.SQBG_BUTTON
    },
    // 18 显示  重新申请  按钮            复议有
    [btnType.CXSQFY_BUTTON]: {
        text: '重新申请',
        type: btnType.CXSQFY_BUTTON
    },
    // 19 显示 申请开票 按钮              担保有
    [btnType.SQKP_BUTTON]: {
        text: '申请开票',
        type: btnType.SQKP_BUTTON
    },
    // 20 显示 查看申请开票信息 按钮       担保有
    [btnType.CKKP_BUTTON]: {
        text: '查看开票信息',
        type: btnType.CKKP_BUTTON
    },
    // 21 显示 申请退保 按钮               担保有
    [btnType.SQTB_BUTTON]: {
        text: '申请退保',
        type: btnType.SQTB_BUTTON
    }
};
// 申请保全类型MAP对象
const SQBQ_TYPE_MAP = {
    ...COMMON_TYPE_MAP,
    // 17 显示  申请复议  按钮            申请保全有
    [SQBQ_BTN_TYPE.SQFY_BUTTON]: {
        text: '申请复议',
        key: 'sqfy',
        type: SQBQ_BTN_TYPE.SQFY_BUTTON
    }
};
// 申请担保类型map对象
const SQDB_TYPE_MAP = {
    ...COMMON_TYPE_MAP,
    // 17 显示  查看评价  按钮            担保有
    [SQDB_BTN_TYPE.CKPJ_BUTTON]: {
        text: '查看评价',
        key: 'ckpj',
        type: SQDB_BTN_TYPE.CKPJ_BUTTON
    }
};
// 申请担保，显示的按钮列表
const SQDB_SHOW_BTN_LIST = [
    // 下载保函 按钮
    SQDB_BTN_TYPE.XZBH_BUTTON,
    // 下载保函 按钮
    SQDB_BTN_TYPE.XZBD_BUTTON,
    // 编辑 按钮
    SQDB_BTN_TYPE.BJ_BUTTON,
    // 删除 按钮
    SQDB_BTN_TYPE.SC_BUTTON,
    // 交费 按钮
    SQDB_BTN_TYPE.JF_BUTTON,
    // 申请开票 按钮
    SQDB_BTN_TYPE.SQKP_BUTTON,
    // 查看申请开票信息 按钮
    SQDB_BTN_TYPE.CKKP_BUTTON,
    // 申请退保 按钮
    SQDB_BTN_TYPE.SQTB_BUTTON,
    // 重新申请 按钮
    SQDB_BTN_TYPE.CXSQ_BUTTON,
    // 申请变更 按钮
    SQDB_BTN_TYPE.SQBG_BUTTON,
    // 申请保全 按钮
    SQDB_BTN_TYPE.SQBQ_BUTTON
];
// 申请保全，显示的按钮列表
const SQBQ_SHOW_BTN_LIST = [
    // 编辑 按钮
    SQBQ_BTN_TYPE.BJ_BUTTON,
    // 删除 按钮
    SQBQ_BTN_TYPE.SC_BUTTON,
    // 交费 按钮
    SQBQ_BTN_TYPE.JF_BUTTON,
    // 补充材料 按钮
    SQBQ_BTN_TYPE.BCCL_BUTTON,
    // 解除保全 按钮
    SQBQ_BTN_TYPE.JCBQ_BUTTON,
    // 变更担保 按钮
    SQBQ_BTN_TYPE.BGDB_BUTTON,
    // 补充担保 按钮
    SQBQ_BTN_TYPE.BCDB_BUTTON,
    // 续行保全 按钮
    SQBQ_BTN_TYPE.XXBQ_BUTTON,
    // 申请复议 按钮
    SQBQ_BTN_TYPE.SQFY_BUTTON
];
const mbxzts = "请前往https://baoquan.court.gov.cn下载相关模板";

// 文件限制
const FILE_LIMIT = {
    // 文件类型
    type: ['image/jpg', 'image/png', 'image/jpeg', 'image/bmp', 'image/gif'],
    // 对应的格式
    format: ['jpg', 'png', 'jpeg', 'bmp', 'gif'],
    size: 20 * 1024 * 1024
};
export {
    normalCodeType,
    btnType,
    SQBQ_BTN_TYPE,
    SQBQ_TYPE_MAP,
    SQBQ_SHOW_BTN_LIST,
    SQDB_BTN_TYPE,
    SQDB_TYPE_MAP,
    SQDB_SHOW_BTN_LIST,
    mbxzts,
    FILE_LIMIT
};
